// flattens all nested object attributes
// when nested objects contain duplicate keys the first to be flattened takes precedence
export const flatten = (obj) => {
  const flattened = {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      Object.assign(flattened, flatten(value));
    } else {
      flattened[key] = value;
    }
  });

  return flattened;
};
